import { create } from 'zustand';

type Mode = 'confirm' | 'progress' | 'complete';

interface DownloadModalState {
  isOpen: boolean;
  mode: Mode;
  isLoading: boolean;
  totalData: number;
  limitPerFile: number;
  totalBatches: number;
  progress: number;
  date?: Date;
  title?: string;
  onConfirm?: () => Promise<void> | void;
  onCancel?: () => void;
  openModal: (payload: {
    totalData: number;
    title?: string;
    limitPerFile: number;
    date?: Date;
    onConfirm: () => Promise<void> | void;
    onCancel: () => void;
  }) => void;

  closeModal: () => void;
  setMode: (mode: Mode) => void;
  setLoading: (loading: boolean) => void;
  setProgress: (current: number, total?: number) => void;
}

export const useDownloadModalStore = create<DownloadModalState>((set) => ({
  isOpen: false,
  mode: 'confirm',
  isLoading: false,

  totalData: 0,
  limitPerFile: 100_000,
  totalBatches: 0,
  progress: 0,
  date: undefined,
  title: '',

  onConfirm: undefined,
  onCancel: undefined,

  openModal: ({ totalData, limitPerFile, date, title, onConfirm, onCancel }) =>
    set(() => ({
      isOpen: true,
      mode: 'confirm',
      isLoading: false,
      totalData,
      limitPerFile,
      totalBatches: Math.ceil((totalData || 0) / (limitPerFile || 1)),
      progress: 0,
      date,
      title,
      onConfirm,
      onCancel,
    })),

  closeModal: () =>
    set(() => ({
      isOpen: false,
      mode: 'confirm',
      isLoading: false,
      totalData: 0,
      totalBatches: 0,
      progress: 0,
      onConfirm: undefined,
      onCancel: undefined,
    })),

  setMode: (mode) => set({ mode }),
  setLoading: (isLoading) => set({ isLoading }),
  setProgress: (current, total) =>
    set((s) => ({
      progress: current,
      totalBatches: total ?? s.totalBatches,
      mode:
        current >= (total ?? s.totalBatches) && (total ?? s.totalBatches) > 0 ? 'complete' : s.mode,
    })),
}));
